export default __webpack_public_path__ + "static/media/BRIK_logo_black_1.ee70a1e7.svg";